import { AllocationTier } from '@decub8/ui';
import { commify } from '@ethersproject/units';

import { ITier } from '@src/ts/interfaces';

import { LineFitter } from './linefitter';

// Function to calculate the stake amount dynamically
export const calculateAmountToStake = (
    user_allocation_multiplier: number,
    multiplier: number,
    base_amount: number,
    user_power: number,
    actual_user_stake: number,
): number => {
    const is_current_multi_value_base_tier = multiplier === 1;
    // when the user is on base tier and has less than the minimum stake we need to use their actual stake rather than the dcb power
    const should_use_actual_stake =
        base_amount === user_power && actual_user_stake < user_power;

    const amount_to_use = is_current_multi_value_base_tier
        ? user_power
        : should_use_actual_stake
        ? actual_user_stake
        : user_power;

    const desired_stake = base_amount * multiplier;
    const amount_to_stake = desired_stake - amount_to_use;

    if (Math.round(user_allocation_multiplier) === Math.round(multiplier))
        return 0;

    return amount_to_stake;
};

export const getAmountToStakeObj = (
    amount_token_to_stake: number,
    token_price: number,
) => {
    const usd_stake = amount_token_to_stake * token_price;

    return {
        usd: `(~$${commify(usd_stake.toFixed(2))})`,
        token: `${commify(amount_token_to_stake.toFixed(2))} DCB`,
    };
};

export const getMultiplyAmount = (
    this_tier: ITier,
    actual_min_tier_limit: number,
): number => {
    if (this_tier.min_limit === actual_min_tier_limit) {
        return 1;
    }

    const base = actual_min_tier_limit;
    const tier = this_tier?.min_limit;
    return tier / base;
};

export const percentageToMultiplier = (
    percentage: number,
    tiers: ITier[],
    actual_min_tier_limit: number,
): number => {
    const step = 100 / (tiers.length - 1);
    const points = tiers.map((tier, index) => [
        step * index,
        getMultiplyAmount(tier, actual_min_tier_limit),
    ]);

    return new LineFitter(points).interpolate(percentage);
};

export const getCurrentTier = (
    value: number,
    tiers: AllocationTier[],
): AllocationTier => {
    return tiers.reduce((current, tier) => {
        return value >= tier.min_limit ? tier : current;
    }, tiers[0]);
};

export const getAvailableTiers = (
    currentTier: AllocationTier,
    tiers: AllocationTier[],
): AllocationTier[] => {
    const currentIndex = tiers?.findIndex(
        (tier) => tier?.id === currentTier?.id,
    );
    return currentIndex >= 0 ? tiers.slice(currentIndex + 1) : [];
};
